
import "./AddDocketDetailsModal.css";
import { MdCancel, MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import useAddDocketDetails from "./AddDocketDetailsModalLogic";

const AddDocketDetailsModal = ({ onClose, refreshList, editData, existingDockets }) => {

  const {
    datasetList,
    isOpen,
    setIsOpen,
    job,
    setJob,
    errors,
    loading,
    handleChange,
    handleSave,
    isEditMode
  } = useAddDocketDetails(onClose, refreshList, editData, existingDockets);


  return (
    <div className="adddocketdetails-modal">
      <div className="adddocketdetails-container">

        {/* HEADER */}
        <div className="adddocketdetails-header">
          <span>
            {isEditMode ? "Edit Docket Details" : "Add Docket Details"}
          </span>
          <MdCancel
            className="adddocketdetails-close"
            onClick={onClose}
          />
        </div>

        {/* BODY */}
        <div className="adddocketdetails-body">

          <div className="adddocketdetails-grid">

            {/* DATASET */}
            <div className="adddocketdetails-field">
              <label className="form-label">Dataset ID</label>


              <div className={`custom-select ${errors.dataset_id ? "is-invalid" : ""} ${isEditMode ? "disabled" : ""}`}>
                <div
                  className="custom-select-trigger"
                  onClick={(e) => {

                    if (isEditMode) return;
                    e.stopPropagation();
                    setIsOpen(prev => !prev);
                  }}
                >
                  <span className={!job.dataset_id ? "placeholder" : ""}>
                    {job.dataset_id || "Select Dataset"}
                  </span>
                  {!isEditMode && (
                    <span className="dropdown-icon">
                      {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                    </span>
                  )}
                </div>

                {!isEditMode && isOpen && (
                  <div className="custom-select-dropdown">
                    {datasetList.map(item => (
                      <div
                        key={item.datasetID}
                        className="custom-option"
                        onClick={() => {
                          setJob(prev => ({ ...prev, dataset_id: item.datasetID }));
                          setIsOpen(false);
                        }}
                      >
                        {item.datasetID}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {errors.dataset_id && (
                <div className="adddocketdetails-error">
                  {errors.dataset_id}
                </div>
              )}
            </div>
      
            {/* CONTAINER */}
            <div className="adddocketdetails-field">
              <label className="form-label">Container Count</label>
              <input
                type="number"
                className={`form-control ${errors.container_count ? "is-invalid" : ""}`}
                name="container_count"
                value={job.container_count}
                onChange={handleChange}
                min="0"
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                }}
              />
              {errors.container_count && (
                <div className="adddocketdetails-error">
                  {errors.container_count}
                </div>
              )}
            </div>

            {/* DOCKER */}
            <div className="adddocketdetails-field adddocketdetails-full">
              <label className="form-label">Docker Image</label>
              <input
                className={`form-control ${errors.docker_image_path ? "is-invalid" : ""}`}
                name="docker_image_path"
                value={job.docker_image_path}
                onChange={handleChange}
              />
              {errors.docker_image_path && (
                <div className="adddocketdetails-error">
                  {errors.docker_image_path}
                </div>
              )}
            </div>

          </div>

          {/* FOOTER */}
          <div className="adddocketdetails-footer">
            <button
              className="adddocketdetails-save-btn"
              onClick={handleSave}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : isEditMode
                  ? "Update"
                  : "Save"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AddDocketDetailsModal;